import { render, staticRenderFns } from "./ui-right-block.vue?vue&type=template&id=db589bce&scoped=true&"
import script from "./ui-right-block.vue?vue&type=script&lang=js&"
export * from "./ui-right-block.vue?vue&type=script&lang=js&"
import style0 from "./ui-right-block.vue?vue&type=style&index=0&id=db589bce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db589bce",
  null
  
)

export default component.exports